// Navigation copy definitions

const navigationCopy = {
  welcome: 'Welcome to Quintessence Games',
  logo: 'Welcome to QG',
  links: {
    about: 'Information',
    join: 'Meet-the-Team'
  },
  contactButton: {
    label: 'Get in Touch',
    ariaLabel: 'Get in Touch with Quintessence Games'
  }
};

export default navigationCopy;
